var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM14.623 8H25.3767C29.0289 8 32.0001 10.9712 32 14.6231V25.3769C32 29.0288 29.0289 32 25.3767 32H14.623C10.9711 32 8 29.0289 8 25.3769V14.6231C8 10.9712 10.9711 8 14.623 8ZM25.3769 29.8706C27.8548 29.8706 29.8707 27.8548 29.8707 25.3769H29.8706V14.6231C29.8706 12.1454 27.8546 10.1294 25.3767 10.1294H14.623C12.1452 10.1294 10.1294 12.1454 10.1294 14.6231V25.3769C10.1294 27.8548 12.1452 29.8707 14.623 29.8706H25.3769ZM19.9993 13.8125C16.5893 13.8125 13.8151 16.5867 13.8151 19.9967C13.8151 23.4066 16.5893 26.1806 19.9993 26.1806C23.4093 26.1806 26.1835 23.4066 26.1835 19.9967C26.1835 16.5867 23.4093 13.8125 19.9993 13.8125ZM19.9993 24.0511C17.7636 24.0511 15.9445 22.2323 15.9445 19.9965C15.9445 17.7607 17.7634 15.9418 19.9993 15.9418C22.2352 15.9418 24.0541 17.7607 24.0541 19.9965C24.0541 22.2323 22.235 24.0511 19.9993 24.0511ZM25.3413 12.4665C25.6311 12.1755 26.0341 12.0094 26.4444 12.0094C26.8561 12.0094 27.2592 12.1755 27.5488 12.4665C27.8398 12.7561 28.0059 13.1592 28.0059 13.5709C28.0059 13.9812 27.8398 14.3844 27.5488 14.6754C27.2578 14.965 26.8561 15.1325 26.4444 15.1325C26.0341 15.1325 25.6309 14.965 25.3413 14.6754C25.0503 14.3844 24.8828 13.9813 24.8828 13.5709C24.8828 13.1592 25.0502 12.7561 25.3413 12.4665Z",
    fill: "url(#paint0_linear_17861_265289)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17861_265289",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7042C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F76F40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d4714c7a3b2ecdf919ee441479f0f139.svg";
export { ForwardRef as ReactComponent };